/**
 * Escapes Markdown special characters in a string to prevent unwanted formatting
 * @param text - The text to escape
 * @returns The escaped text with backslashes before Markdown special characters
 */
export const escapeMarkdown = (text: string): string => {
  // List of Markdown special characters that need to be escaped
  const markdownChars = [
    "\\", // Backslash (must be first to avoid double escaping)
    "`", // Code backticks
    "*", // Bold/italic asterisks
    "_", // Bold/italic underscores
    "{", // Curly braces
    "}", // Curly braces
    "[", // Square brackets
    "]", // Square brackets
    "(", // Parentheses
    ")", // Parentheses
    "#", // Headers
    "+", // Lists
    "-", // Lists
    ".", // Lists
    "!", // Images
    "|", // Tables
    "~", // Strikethrough
    "<sup>",
    "</sup>",
    "<sub>",
    "</sub>",
  ]

  let escapedText = text

  // Escape each special character
  markdownChars.forEach((char) => {
    const regex = new RegExp(`\\${char}`, "g")
    escapedText = escapedText.replace(regex, `\\${char}`)
  })

  return escapedText
}
